"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetsFileServiceServer = exports.AssetsFileServiceDispatcher = exports.AssetsFileServiceClient = void 0;
var octopus_common_1 = require("@playq/octopus-common");
var FileFeature_1 = require("./FileFeature");
var CheckFileResponse_1 = require("./CheckFileResponse");
var DownloadSingleResponse_1 = require("./DownloadSingleResponse");
var File_1 = require("./File");
var QueryFilesResponse_1 = require("./QueryFilesResponse");
var services_shared_1 = require("@playq/services-shared");
var FileResponse_1 = require("./FileResponse");
var UploadBatchResponse_1 = require("./UploadBatchResponse");
var FileID_1 = require("./FileID");
var FileRevision_1 = require("./FileRevision");
var UploadSingleResponse_1 = require("./UploadSingleResponse");
var FilesSort_1 = require("./FilesSort");
var QueryTagsResponse_1 = require("./QueryTagsResponse");
var CreativeAssetsPolicy_1 = require("./CreativeAssetsPolicy");
var FileRevisionID_1 = require("./FileRevisionID");
var CheckFileRequest_1 = require("./CheckFileRequest");
var QueryIntelliTagResponse_1 = require("./QueryIntelliTagResponse");
var UploadFileEntryRequest_1 = require("./UploadFileEntryRequest");
var FileRevisionContent_1 = require("./FileRevisionContent");
var MissingRevisions_1 = require("./MissingRevisions");
var CheckFilesBatchResponse_1 = require("./CheckFilesBatchResponse");
var VideoPoint_1 = require("./VideoPoint");
var irt_1 = require("@playq/irt");
var InPolicy = (function () {
    function InPolicy(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    InPolicy.prototype.serialize = function () {
        return {};
    };
    return InPolicy;
}());
var OutPolicyHelpers = (function () {
    function OutPolicyHelpers() {
    }
    OutPolicyHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutPolicyHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new CreativeAssetsPolicy_1.CreativeAssetsPolicy(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutPolicyHelpers;
}());
var InUploadFileEntity = (function () {
    function InUploadFileEntity(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.payload = new UploadFileEntryRequest_1.UploadFileEntryRequest(data.payload);
    }
    Object.defineProperty(InUploadFileEntity.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUploadFileEntity.prototype, "payload", {
        get: function () {
            return this._payload;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field payload is not optional');
            }
            this._payload = value;
        },
        enumerable: false,
        configurable: true
    });
    InUploadFileEntity.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            payload: this.payload.serialize()
        };
    };
    return InUploadFileEntity;
}());
var OutUploadFileEntityHelpers = (function () {
    function OutUploadFileEntityHelpers() {
    }
    OutUploadFileEntityHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUploadFileEntityHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new UploadSingleResponse_1.UploadSingleResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUploadFileEntityHelpers;
}());
var InUploadBatch = (function () {
    function InUploadBatch(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.upload = data.upload.map(function (e) { return new UploadFileEntryRequest_1.UploadFileEntryRequest(e); });
    }
    Object.defineProperty(InUploadBatch.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUploadBatch.prototype, "upload", {
        get: function () {
            return this._upload;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field upload is not optional');
            }
            this._upload = value;
        },
        enumerable: false,
        configurable: true
    });
    InUploadBatch.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            upload: this.upload.map(function (e) { return e.serialize(); })
        };
    };
    return InUploadBatch;
}());
var OutUploadBatchHelpers = (function () {
    function OutUploadBatchHelpers() {
    }
    OutUploadBatchHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUploadBatchHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new UploadBatchResponse_1.UploadBatchResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUploadBatchHelpers;
}());
var InUploadRetry = (function () {
    function InUploadRetry(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.id = new FileRevisionID_1.FileRevisionID(data.id);
        this.mime = data.mime;
        this.sha256 = data.sha256;
    }
    Object.defineProperty(InUploadRetry.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUploadRetry.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUploadRetry.prototype, "mime", {
        get: function () {
            return this._mime;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field mime is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field mime expects type string, got ' + value);
            }
            this._mime = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUploadRetry.prototype, "sha256", {
        get: function () {
            return this._sha256;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sha256 is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field sha256 expects type string, got ' + value);
            }
            this._sha256 = value;
        },
        enumerable: false,
        configurable: true
    });
    InUploadRetry.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            id: this.id.serialize(),
            mime: this.mime,
            sha256: this.sha256
        };
    };
    return InUploadRetry;
}());
var OutUploadRetryHelpers = (function () {
    function OutUploadRetryHelpers() {
    }
    OutUploadRetryHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUploadRetryHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new UploadSingleResponse_1.UploadSingleResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUploadRetryHelpers;
}());
var InUpdate = (function () {
    function InUpdate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.file = new File_1.File(data.file);
        this.tags = data.tags.map(function (e) { return new octopus_common_1.Tag(e); });
    }
    Object.defineProperty(InUpdate.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdate.prototype, "file", {
        get: function () {
            return this._file;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field file is not optional');
            }
            this._file = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdate.prototype, "tags", {
        get: function () {
            return this._tags;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field tags is not optional');
            }
            this._tags = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdate.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            file: this.file.serialize(),
            tags: this.tags.map(function (e) { return e.serialize(); })
        };
    };
    return InUpdate;
}());
var OutUpdateHelpers = (function () {
    function OutUpdateHelpers() {
    }
    OutUpdateHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateHelpers;
}());
var InUpdateRevision = (function () {
    function InUpdateRevision(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.revision = new FileRevision_1.FileRevision(data.revision);
    }
    Object.defineProperty(InUpdateRevision.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateRevision.prototype, "revision", {
        get: function () {
            return this._revision;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field revision is not optional');
            }
            this._revision = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateRevision.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            revision: this.revision.serialize()
        };
    };
    return InUpdateRevision;
}());
var OutUpdateRevisionHelpers = (function () {
    function OutUpdateRevisionHelpers() {
    }
    OutUpdateRevisionHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateRevisionHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateRevisionHelpers;
}());
var InDelete = (function () {
    function InDelete(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.id = new FileID_1.FileID(data.id);
    }
    Object.defineProperty(InDelete.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDelete.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InDelete.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            id: this.id.serialize()
        };
    };
    return InDelete;
}());
var OutDeleteHelpers = (function () {
    function OutDeleteHelpers() {
    }
    OutDeleteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteHelpers;
}());
var InDeleteBatch = (function () {
    function InDeleteBatch(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.ids = data.ids.map(function (e) { return new FileID_1.FileID(e); });
    }
    Object.defineProperty(InDeleteBatch.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteBatch.prototype, "ids", {
        get: function () {
            return this._ids;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ids is not optional');
            }
            this._ids = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteBatch.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            ids: this.ids.map(function (e) { return e.serialize(); })
        };
    };
    return InDeleteBatch;
}());
var OutDeleteBatchHelpers = (function () {
    function OutDeleteBatchHelpers() {
    }
    OutDeleteBatchHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteBatchHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteBatchHelpers;
}());
var InDeleteRevision = (function () {
    function InDeleteRevision(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.id = new FileRevisionID_1.FileRevisionID(data.id);
    }
    Object.defineProperty(InDeleteRevision.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteRevision.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteRevision.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            id: this.id.serialize()
        };
    };
    return InDeleteRevision;
}());
var OutDeleteRevisionHelpers = (function () {
    function OutDeleteRevisionHelpers() {
    }
    OutDeleteRevisionHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteRevisionHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteRevisionHelpers;
}());
var InCheckFileRevisions = (function () {
    function InCheckFileRevisions(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.revisions = data.revisions.map(function (e) { return new FileRevisionID_1.FileRevisionID(e); });
    }
    Object.defineProperty(InCheckFileRevisions.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InCheckFileRevisions.prototype, "revisions", {
        get: function () {
            return this._revisions;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field revisions is not optional');
            }
            this._revisions = value;
        },
        enumerable: false,
        configurable: true
    });
    InCheckFileRevisions.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            revisions: this.revisions.map(function (e) { return e.serialize(); })
        };
    };
    return InCheckFileRevisions;
}());
var OutCheckFileRevisionsHelpers = (function () {
    function OutCheckFileRevisionsHelpers() {
    }
    OutCheckFileRevisionsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutCheckFileRevisionsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new MissingRevisions_1.MissingRevisions(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutCheckFileRevisionsHelpers;
}());
var InGetFile = (function () {
    function InGetFile(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.id = new FileID_1.FileID(data.id);
        this.features = data.features.map(function (e) { return FileFeature_1.FileFeature[e]; });
    }
    Object.defineProperty(InGetFile.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetFile.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetFile.prototype, "features", {
        get: function () {
            return this._features;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field features is not optional');
            }
            this._features = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetFile.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            id: this.id.serialize(),
            features: this.features.map(function (e) { return FileFeature_1.FileFeature[e]; })
        };
    };
    return InGetFile;
}());
var OutGetFileHelpers = (function () {
    function OutGetFileHelpers() {
    }
    OutGetFileHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutGetFileHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new FileResponse_1.FileResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutGetFileHelpers;
}());
var InGetFileRevisionContent = (function () {
    function InGetFileRevisionContent(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.revision = new FileRevisionID_1.FileRevisionID(data.revision);
    }
    Object.defineProperty(InGetFileRevisionContent.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InGetFileRevisionContent.prototype, "revision", {
        get: function () {
            return this._revision;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field revision is not optional');
            }
            this._revision = value;
        },
        enumerable: false,
        configurable: true
    });
    InGetFileRevisionContent.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            revision: this.revision.serialize()
        };
    };
    return InGetFileRevisionContent;
}());
var OutGetFileRevisionContentHelpers = (function () {
    function OutGetFileRevisionContentHelpers() {
    }
    OutGetFileRevisionContentHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutGetFileRevisionContentHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new FileRevisionContent_1.FileRevisionContent(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutGetFileRevisionContentHelpers;
}());
var InCheckFile = (function () {
    function InCheckFile(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.check = CheckFileRequest_1.CheckFileRequestHelpers.deserialize(data.check);
    }
    Object.defineProperty(InCheckFile.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InCheckFile.prototype, "check", {
        get: function () {
            return this._check;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field check is not optional');
            }
            this._check = value;
        },
        enumerable: false,
        configurable: true
    });
    InCheckFile.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            check: CheckFileRequest_1.CheckFileRequestHelpers.serialize(this.check)
        };
    };
    return InCheckFile;
}());
var OutCheckFileHelpers = (function () {
    function OutCheckFileHelpers() {
    }
    OutCheckFileHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutCheckFileHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new CheckFileResponse_1.CheckFileResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutCheckFileHelpers;
}());
var InCheckFilesBatch = (function () {
    function InCheckFilesBatch(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.batch = data.batch.map(function (e) { return CheckFileRequest_1.CheckFileRequestHelpers.deserialize(e); });
    }
    Object.defineProperty(InCheckFilesBatch.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InCheckFilesBatch.prototype, "batch", {
        get: function () {
            return this._batch;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field batch is not optional');
            }
            this._batch = value;
        },
        enumerable: false,
        configurable: true
    });
    InCheckFilesBatch.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            batch: this.batch.map(function (e) { return CheckFileRequest_1.CheckFileRequestHelpers.serialize(e); })
        };
    };
    return InCheckFilesBatch;
}());
var OutCheckFilesBatchHelpers = (function () {
    function OutCheckFilesBatchHelpers() {
    }
    OutCheckFilesBatchHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutCheckFilesBatchHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new CheckFilesBatchResponse_1.CheckFilesBatchResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutCheckFilesBatchHelpers;
}());
var InDownload = (function () {
    function InDownload(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.revision = new FileRevisionID_1.FileRevisionID(data.revision);
        this.preview = data.preview;
    }
    Object.defineProperty(InDownload.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDownload.prototype, "revision", {
        get: function () {
            return this._revision;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field revision is not optional');
            }
            this._revision = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDownload.prototype, "preview", {
        get: function () {
            return this._preview;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field preview is not optional');
            }
            if (typeof value !== 'boolean') {
                throw new Error('Field preview expects boolean type, got ' + value);
            }
            this._preview = value;
        },
        enumerable: false,
        configurable: true
    });
    InDownload.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            revision: this.revision.serialize(),
            preview: this.preview
        };
    };
    return InDownload;
}());
var OutDownloadHelpers = (function () {
    function OutDownloadHelpers() {
    }
    OutDownloadHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDownloadHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new DownloadSingleResponse_1.DownloadSingleResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDownloadHelpers;
}());
var InQueryTags = (function () {
    function InQueryTags(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.hint = data.hint;
        this.iterator = typeof data.iterator !== 'undefined' ? new services_shared_1.OffsetLimit(data.iterator) : undefined;
        this.filterSystemTags = data.filterSystemTags;
    }
    Object.defineProperty(InQueryTags.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryTags.prototype, "hint", {
        get: function () {
            return this._hint;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field hint is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field hint expects type string, got ' + value);
            }
            this._hint = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryTags.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._iterator = undefined;
                return;
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryTags.prototype, "filterSystemTags", {
        get: function () {
            return this._filterSystemTags;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterSystemTags is not optional');
            }
            if (typeof value !== 'boolean') {
                throw new Error('Field filterSystemTags expects boolean type, got ' + value);
            }
            this._filterSystemTags = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryTags.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            hint: this.hint,
            iterator: typeof this.iterator !== 'undefined' ? this.iterator.serialize() : undefined,
            filterSystemTags: this.filterSystemTags
        };
    };
    return InQueryTags;
}());
var OutQueryTagsHelpers = (function () {
    function OutQueryTagsHelpers() {
    }
    OutQueryTagsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryTagsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new QueryTagsResponse_1.QueryTagsResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryTagsHelpers;
}());
var InQueryIntelliTags = (function () {
    function InQueryIntelliTags(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
    }
    Object.defineProperty(InQueryIntelliTags.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryIntelliTags.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryIntelliTags.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryIntelliTags.prototype.serialize = function () {
        var _this = this;
        return {
            appId: this.appId.serialize(),
            iterator: this.iterator.serialize(),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {})
        };
    };
    return InQueryIntelliTags;
}());
var OutQueryIntelliTagsHelpers = (function () {
    function OutQueryIntelliTagsHelpers() {
    }
    OutQueryIntelliTagsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryIntelliTagsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new QueryIntelliTagResponse_1.QueryIntelliTagResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryIntelliTagsHelpers;
}());
var InQueryFiles = (function () {
    function InQueryFiles(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.features = data.features.map(function (e) { return FileFeature_1.FileFeature[e]; });
        this.sortBy = data.sortBy.map(function (e) { return new FilesSort_1.FilesSort(e); });
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
    }
    Object.defineProperty(InQueryFiles.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryFiles.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryFiles.prototype, "features", {
        get: function () {
            return this._features;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field features is not optional');
            }
            this._features = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryFiles.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sortBy is not optional');
            }
            this._sortBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryFiles.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryFiles.prototype.serialize = function () {
        var _this = this;
        return {
            appId: this.appId.serialize(),
            iterator: this.iterator.serialize(),
            features: this.features.map(function (e) { return FileFeature_1.FileFeature[e]; }),
            sortBy: this.sortBy.map(function (e) { return e.serialize(); }),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {})
        };
    };
    return InQueryFiles;
}());
var OutQueryFilesHelpers = (function () {
    function OutQueryFilesHelpers() {
    }
    OutQueryFilesHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryFilesHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new QueryFilesResponse_1.QueryFilesResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryFilesHelpers;
}());
var InUpdateThumbnail = (function () {
    function InUpdateThumbnail(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.appId = new octopus_common_1.AppID(data.appId);
        this.id = new FileID_1.FileID(data.id);
        this.version = typeof data.version !== 'undefined' ? data.version : undefined;
        this.point = typeof data.point !== 'undefined' ? VideoPoint_1.VideoPointHelpers.deserialize(data.point) : undefined;
    }
    Object.defineProperty(InUpdateThumbnail.prototype, "appId", {
        get: function () {
            return this._appId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field appId is not optional');
            }
            this._appId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateThumbnail.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateThumbnail.prototype, "version", {
        get: function () {
            return this._version;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._version = undefined;
                return;
            }
            if (typeof value !== 'number') {
                throw new Error('Field version expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field version is expected to be an integer, got ' + value);
            }
            if (value < 0) {
                throw new Error('Field version is expected to be not less than 0, got ' + value);
            }
            if (value > 4294967295) {
                throw new Error('Field version is expected to be not greater than 4294967295, got ' + value);
            }
            this._version = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InUpdateThumbnail.prototype, "point", {
        get: function () {
            return this._point;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._point = undefined;
                return;
            }
            this._point = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateThumbnail.prototype.serialize = function () {
        return {
            appId: this.appId.serialize(),
            id: this.id.serialize(),
            version: typeof this.version !== 'undefined' ? this.version : undefined,
            point: typeof this.point !== 'undefined' ? VideoPoint_1.VideoPointHelpers.serialize(this.point) : undefined
        };
    };
    return InUpdateThumbnail;
}());
var OutUpdateThumbnailHelpers = (function () {
    function OutUpdateThumbnailHelpers() {
    }
    OutUpdateThumbnailHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateThumbnailHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateThumbnailHelpers;
}());
var AssetsFileServiceClient = (function () {
    function AssetsFileServiceClient(transport) {
        this._transport = transport;
    }
    AssetsFileServiceClient.prototype.getPackageName = function () { return AssetsFileServiceClient.PackageName; };
    AssetsFileServiceClient.prototype.getClassName = function () { return AssetsFileServiceClient.ClassName; };
    AssetsFileServiceClient.prototype.getFullClassName = function () { return AssetsFileServiceClient.FullClassName; };
    AssetsFileServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.policy = function () {
        var _this = this;
        var __data = new InPolicy();
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'policy', __data)
                .then(function (data) {
                try {
                    resolve(OutPolicyHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.uploadFileEntity = function (appId, payload) {
        var _this = this;
        var __data = new InUploadFileEntity();
        __data.appId = appId;
        __data.payload = payload;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'uploadFileEntity', __data)
                .then(function (data) {
                try {
                    resolve(OutUploadFileEntityHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.uploadBatch = function (appId, upload) {
        var _this = this;
        var __data = new InUploadBatch();
        __data.appId = appId;
        __data.upload = upload;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'uploadBatch', __data)
                .then(function (data) {
                try {
                    resolve(OutUploadBatchHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.uploadRetry = function (appId, id, mime, sha256) {
        var _this = this;
        var __data = new InUploadRetry();
        __data.appId = appId;
        __data.id = id;
        __data.mime = mime;
        __data.sha256 = sha256;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'uploadRetry', __data)
                .then(function (data) {
                try {
                    resolve(OutUploadRetryHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.update = function (appId, file, tags) {
        var _this = this;
        var __data = new InUpdate();
        __data.appId = appId;
        __data.file = file;
        __data.tags = tags;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'update', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.updateRevision = function (appId, revision) {
        var _this = this;
        var __data = new InUpdateRevision();
        __data.appId = appId;
        __data.revision = revision;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'updateRevision', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateRevisionHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.delete = function (appId, id) {
        var _this = this;
        var __data = new InDelete();
        __data.appId = appId;
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'delete', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.deleteBatch = function (appId, ids) {
        var _this = this;
        var __data = new InDeleteBatch();
        __data.appId = appId;
        __data.ids = ids;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'deleteBatch', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteBatchHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.deleteRevision = function (appId, id) {
        var _this = this;
        var __data = new InDeleteRevision();
        __data.appId = appId;
        __data.id = id;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'deleteRevision', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteRevisionHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.checkFileRevisions = function (appId, revisions) {
        var _this = this;
        var __data = new InCheckFileRevisions();
        __data.appId = appId;
        __data.revisions = revisions;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'checkFileRevisions', __data)
                .then(function (data) {
                try {
                    resolve(OutCheckFileRevisionsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.getFile = function (appId, id, features) {
        var _this = this;
        var __data = new InGetFile();
        __data.appId = appId;
        __data.id = id;
        __data.features = features;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'getFile', __data)
                .then(function (data) {
                try {
                    resolve(OutGetFileHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.getFileRevisionContent = function (appId, revision) {
        var _this = this;
        var __data = new InGetFileRevisionContent();
        __data.appId = appId;
        __data.revision = revision;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'getFileRevisionContent', __data)
                .then(function (data) {
                try {
                    resolve(OutGetFileRevisionContentHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.checkFile = function (appId, check) {
        var _this = this;
        var __data = new InCheckFile();
        __data.appId = appId;
        __data.check = check;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'checkFile', __data)
                .then(function (data) {
                try {
                    resolve(OutCheckFileHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.checkFilesBatch = function (appId, batch) {
        var _this = this;
        var __data = new InCheckFilesBatch();
        __data.appId = appId;
        __data.batch = batch;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'checkFilesBatch', __data)
                .then(function (data) {
                try {
                    resolve(OutCheckFilesBatchHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.download = function (appId, revision, preview) {
        var _this = this;
        var __data = new InDownload();
        __data.appId = appId;
        __data.revision = revision;
        __data.preview = preview;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'download', __data)
                .then(function (data) {
                try {
                    resolve(OutDownloadHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.queryTags = function (appId, hint, iterator, filterSystemTags) {
        var _this = this;
        var __data = new InQueryTags();
        __data.appId = appId;
        __data.hint = hint;
        __data.iterator = iterator;
        __data.filterSystemTags = filterSystemTags;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'queryTags', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryTagsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.queryIntelliTags = function (appId, iterator, filterBy) {
        var _this = this;
        var __data = new InQueryIntelliTags();
        __data.appId = appId;
        __data.iterator = iterator;
        __data.filterBy = filterBy;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'queryIntelliTags', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryIntelliTagsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.queryFiles = function (appId, iterator, features, sortBy, filterBy) {
        var _this = this;
        var __data = new InQueryFiles();
        __data.appId = appId;
        __data.iterator = iterator;
        __data.features = features;
        __data.sortBy = sortBy;
        __data.filterBy = filterBy;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'queryFiles', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryFilesHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.prototype.updateThumbnail = function (appId, id, version, point) {
        var _this = this;
        var __data = new InUpdateThumbnail();
        __data.appId = appId;
        __data.id = id;
        __data.version = version;
        __data.point = point;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AssetsFileServiceClient.ClassName, 'updateThumbnail', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateThumbnailHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AssetsFileServiceClient.PackageName = 'net.playq.octopus2.files';
    AssetsFileServiceClient.ClassName = 'AssetsFileService';
    AssetsFileServiceClient.FullClassName = 'net.playq.octopus2.files.AssetsFileService';
    return AssetsFileServiceClient;
}());
exports.AssetsFileServiceClient = AssetsFileServiceClient;
var AssetsFileServiceDispatcher = (function () {
    function AssetsFileServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    AssetsFileServiceDispatcher.prototype.getSupportedService = function () {
        return 'AssetsFileService';
    };
    AssetsFileServiceDispatcher.prototype.getSupportedMethods = function () {
        return AssetsFileServiceDispatcher.methods;
    };
    AssetsFileServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "policy": {
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.policy(context)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutPolicyHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "uploadFileEntity": {
                var obj_1 = new InUploadFileEntity(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.uploadFileEntity(context, obj_1.appId, obj_1.payload)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUploadFileEntityHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "uploadBatch": {
                var obj_2 = new InUploadBatch(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.uploadBatch(context, obj_2.appId, obj_2.upload)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUploadBatchHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "uploadRetry": {
                var obj_3 = new InUploadRetry(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.uploadRetry(context, obj_3.appId, obj_3.id, obj_3.mime, obj_3.sha256)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUploadRetryHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "update": {
                var obj_4 = new InUpdate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.update(context, obj_4.appId, obj_4.file, obj_4.tags)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateRevision": {
                var obj_5 = new InUpdateRevision(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateRevision(context, obj_5.appId, obj_5.revision)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateRevisionHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "delete": {
                var obj_6 = new InDelete(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.delete(context, obj_6.appId, obj_6.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteBatch": {
                var obj_7 = new InDeleteBatch(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteBatch(context, obj_7.appId, obj_7.ids)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteBatchHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteRevision": {
                var obj_8 = new InDeleteRevision(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteRevision(context, obj_8.appId, obj_8.id)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteRevisionHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "checkFileRevisions": {
                var obj_9 = new InCheckFileRevisions(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.checkFileRevisions(context, obj_9.appId, obj_9.revisions)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCheckFileRevisionsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getFile": {
                var obj_10 = new InGetFile(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getFile(context, obj_10.appId, obj_10.id, obj_10.features)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetFileHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "getFileRevisionContent": {
                var obj_11 = new InGetFileRevisionContent(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.getFileRevisionContent(context, obj_11.appId, obj_11.revision)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutGetFileRevisionContentHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "checkFile": {
                var obj_12 = new InCheckFile(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.checkFile(context, obj_12.appId, obj_12.check)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCheckFileHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "checkFilesBatch": {
                var obj_13 = new InCheckFilesBatch(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.checkFilesBatch(context, obj_13.appId, obj_13.batch)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCheckFilesBatchHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "download": {
                var obj_14 = new InDownload(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.download(context, obj_14.appId, obj_14.revision, obj_14.preview)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDownloadHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryTags": {
                var obj_15 = new InQueryTags(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryTags(context, obj_15.appId, obj_15.hint, obj_15.iterator, obj_15.filterSystemTags)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryTagsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryIntelliTags": {
                var obj_16 = new InQueryIntelliTags(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryIntelliTags(context, obj_16.appId, obj_16.iterator, obj_16.filterBy)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryIntelliTagsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryFiles": {
                var obj_17 = new InQueryFiles(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryFiles(context, obj_17.appId, obj_17.iterator, obj_17.features, obj_17.sortBy, obj_17.filterBy)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryFilesHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateThumbnail": {
                var obj_18 = new InUpdateThumbnail(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateThumbnail(context, obj_18.appId, obj_18.id, obj_18.version, obj_18.point)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateThumbnailHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by AssetsFileServiceDispatcher."));
        }
    };
    AssetsFileServiceDispatcher.methods = [
        "policy",
        "uploadFileEntity",
        "uploadBatch",
        "uploadRetry",
        "update",
        "updateRevision",
        "delete",
        "deleteBatch",
        "deleteRevision",
        "checkFileRevisions",
        "getFile",
        "getFileRevisionContent",
        "checkFile",
        "checkFilesBatch",
        "download",
        "queryTags",
        "queryIntelliTags",
        "queryFiles",
        "updateThumbnail"
    ];
    return AssetsFileServiceDispatcher;
}());
exports.AssetsFileServiceDispatcher = AssetsFileServiceDispatcher;
var AssetsFileServiceServer = (function (_super) {
    __extends(AssetsFileServiceServer, _super);
    function AssetsFileServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    AssetsFileServiceServer.prototype.policy = function (context) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.uploadFileEntity = function (context, appId, payload) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.uploadBatch = function (context, appId, upload) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.uploadRetry = function (context, appId, id, mime, sha256) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.update = function (context, appId, file, tags) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.updateRevision = function (context, appId, revision) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.delete = function (context, appId, id) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.deleteBatch = function (context, appId, ids) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.deleteRevision = function (context, appId, id) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.checkFileRevisions = function (context, appId, revisions) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.getFile = function (context, appId, id, features) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.getFileRevisionContent = function (context, appId, revision) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.checkFile = function (context, appId, check) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.checkFilesBatch = function (context, appId, batch) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.download = function (context, appId, revision, preview) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.queryTags = function (context, appId, hint, iterator, filterSystemTags) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.queryIntelliTags = function (context, appId, iterator, filterBy) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.queryFiles = function (context, appId, iterator, features, sortBy, filterBy) {
        throw new Error('Not implemented.');
    };
    AssetsFileServiceServer.prototype.updateThumbnail = function (context, appId, id, version, point) {
        throw new Error('Not implemented.');
    };
    return AssetsFileServiceServer;
}(AssetsFileServiceDispatcher));
exports.AssetsFileServiceServer = AssetsFileServiceServer;
//# sourceMappingURL=AssetsFileService.js.map